export default __webpack_public_path__ + "static/media/Kanwal_Rizvi.821e37d3.png";